import React, { useState } from 'react';
import { WrapNearDefault, WrapNearHover, WrapNearMobile } from './Nav';
import { useClientMobile } from '../../utils/device';

import PolygonRightSvg from '../../assets/svg/PolygonRight.svg';
import WalletIconSvg from '../../assets/svg/WalletIcon.svg';
import AccountIconSvg from '../../assets/svg/AccountIcon.svg';
import GoodBgSvg from '../../assets/svg/GoodBg.svg';
import GoodThumbSvg from '../../assets/svg/GoodThumb.svg';
import RefIconSvg from '../../assets/svg/RefIcon.svg';
import RateExchangeMobileSvg from '../../assets/svg/RateExchangeMobile.svg';

import InfoSvg from '../../assets/svg/infoIcon.svg';
import CustomTooltip from 'src/components/customTooltip/customTooltip';

export const InfoIcon = ({
  tooltip,
  style,
  tooltipNode,
  id,
}: {
  id: string;
  tooltip?: string;
  style?: any;
  tooltipNode?: any;
}) => {
  return (
    <>
      <span
        data-tip={true}
        data-tooltip-id={id}
        className={'cursor-pointer info-icon'}
      >
        <InfoSvg />
      </span>
      {(tooltip || tooltipNode) && (
        <CustomTooltip id={id}>
          {tooltipNode ? tooltipNode : <div style={style}>{tooltip}</div>}
        </CustomTooltip>
      )}
    </>
  );
};

const AccountIcon = () => {
  return <AccountIconSvg />;
};
const WalletIcon = () => {
  return <WalletIconSvg />;
};
const RefIcon = () => {
  return <RefIconSvg />;
};
const GoodBg = () => {
  return <GoodBgSvg />;
};
const GoodThumb = () => {
  return <GoodThumbSvg />;
};
const RateExchangeMobile = () => {
  return <RateExchangeMobileSvg />;
};

const NearIcon = () => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.15789 3.50831V13.6033L8.42105 9.74639L8.94737 10.1991L4.53386 16.296C2.894 17.7715 0 16.7732 0 14.732V2.26796C0 0.156766 3.06343 -0.804874 4.6445 0.809998L16.8421 13.2684V3.58757L12.1053 7.03026L11.5789 6.57757L15.3329 0.886283C16.8997 -0.75849 20 0.19444 20 2.3208V14.5087C20 16.6199 16.9366 17.5815 15.3555 15.9667L3.15789 3.50831Z"
        fill="white"
      />
    </svg>
  );
};
const USDCWIcon = (props: any) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13" cy="13" r="12.5" fill="white" stroke="white" />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        fill="url(#pattern0_6056_7593)"
      />
      <circle cx="18.9761" cy="18.9761" r="5.97609" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9586 23.4964C22.4416 22.9669 24.0254 20.5248 23.4959 18.0418C22.9665 15.5588 20.5244 13.9751 18.0414 14.5045C15.5584 15.0339 13.9746 17.476 14.5041 19.959C15.0335 22.4421 17.4756 24.0258 19.9586 23.4964ZM20.0545 23.9459C22.7858 23.3636 24.5279 20.6773 23.9455 17.9459C23.3632 15.2146 20.6769 13.4725 17.9455 14.0549C15.2142 14.6373 13.4721 17.3236 14.0545 20.0549C14.6368 22.7862 17.3231 24.5283 20.0545 23.9459Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5377 22.9027C22.6482 22.4527 23.9944 20.3769 23.5444 18.2663C23.0944 16.1558 21.0186 14.8096 18.908 15.2596C16.7974 15.7096 15.4513 17.7854 15.9013 19.896C16.3513 22.0066 18.4271 23.3527 20.5377 22.9027ZM20.6335 23.3523C22.9924 22.8493 24.4969 20.5294 23.994 18.1705C23.491 15.8116 21.171 14.3071 18.8122 14.81C16.4533 15.313 14.9487 17.633 15.4517 19.9918C15.9547 22.3507 18.2746 23.8552 20.6335 23.3523Z"
        fill="white"
        fillOpacity="0.9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1167 22.309C22.8548 21.9384 23.9634 20.229 23.5928 18.4909C23.2222 16.7527 21.5128 15.6441 19.7746 16.0147C18.0365 16.3853 16.9279 18.0948 17.2985 19.8329C17.6691 21.571 19.3786 22.6796 21.1167 22.309ZM21.2126 22.7586C23.199 22.3351 24.466 20.3814 24.0424 18.395C23.6189 16.4086 21.6652 15.1416 19.6788 15.5651C17.6923 15.9887 16.4254 17.9423 16.8489 19.9288C17.2725 21.9152 19.2261 23.1822 21.2126 22.7586Z"
        fill="white"
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6938 21.7154C23.0595 21.4242 23.9305 20.081 23.6393 18.7154C23.3481 17.3497 22.005 16.4787 20.6393 16.7699C19.2736 17.061 18.4026 18.4042 18.6938 19.7699C18.985 21.1355 20.3281 22.0066 21.6938 21.7154ZM21.7896 22.165C23.4036 21.8208 24.433 20.2335 24.0889 18.6195C23.7448 17.0055 22.1574 15.9761 20.5434 16.3203C18.9295 16.6644 17.9001 18.2517 18.2442 19.8657C18.5883 21.4797 20.1757 22.5091 21.7896 22.165Z"
        fill="white"
        fillOpacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_6056_7593"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_6056_7593" transform="scale(0.00666667)" />
        </pattern>
        <image
          id="image0_6056_7593"
          width="150"
          height="150"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAK1WlDQ1BJQ0MgUHJvZmlsZQAASImVlwdUU9kWhs+9N73QAhGQEnoTpAgEkBJ6AAXpICohCSSUEBKCil0ZHEFFERHBMqKjAgqOBZCxIBYsDIINCzpBBgF1HCzYUJkLPMLMvPXeW2+vddb+srPPPvvcdc5d/wWA6sURi9NhFQAyRNmS8ABvRmxcPAPfD8gAB0hACRhxuFIxKywsBKA26f9u7+8BaMzfth6r9e///1dT4/GlXACgBJSTeFJuBsrN6PiNK5ZkA4AcQONGi7PFY3wVZXUJ2iDK3WOcMsFDY5w0zhjMeE5kuA/KmgAQKByOJAUAijEaZ+RwU9A6FF+UbUU8oQhl9Dfw4Ao4PJRPojwjIyNzjOUom6P5YgCoBJSZSX+pmfK3+kmK+hxOioIn9jVuBF+hVJzOWfp/Ppr/bRnpssk1TNFBEUgCw8c8+vzup2UGK1iUNDd0koW88fxxFsgCoyaZK/WJn2QexzdYMTd9bsgkJwv92Yo62ezISeZL/SImWZIZrlgrWeLDmmSOZGpdWVqUIi7gsxX1cwWRMZOcI4yeO8nStIjgqRwfRVwiC1f0zxcFeE+t66/Ye4b0L/sVshVzswWRgYq9c6b654tYUzWlsYreeHxfv6mcKEW+ONtbsZY4PUyRz08PUMSlORGKudno4ZyaG6Z4hqmcoLBJBpHAHjgDWxACArL5S8bOKPDJFC+VCFME2QwWesv4DLaIazODYW9r7wDA2J2dOAZv6eN3EaJfn4pluqLHF707yPapWNIAAA0PANAiT8WM0fOvvAiA+k1cmSRnIjZ2nQAWfRMoA3WgBfSAETAH1mh3TsANeAE/EARC0W7jwELABQKQASRgMVgO1oB8UAi2gO2gHOwF+8FhcBQcBw3gDLgAroAboAPcBY+AHPSBF2AIvAcjEAThISpEg7QgfcgEsoLsISbkAflBIVA4FAclQimQCJJBy6F1UCFUDJVD+6Aq6CfoNHQBugZ1Qg+gHmgQegN9hhGYAqvDurApPBNmwiw4GI6EF8ApcBacC+fBm+EyuBI+AtfDF+Ab8F1YDr+AhxGAkBE6YoBYI0zEBwlF4pFkRIKsRAqQUqQSqUWakFbkNiJHXiKfMDgMDcPAWGPcMIGYKAwXk4VZidmIKcccxtRjLmFuY3owQ5hvWCpWB2uFdcWysbHYFOxibD62FHsQewp7GXsX24d9j8Ph6DgznDMuEBeHS8Utw23E7cbV4Zpxnbhe3DAej9fCW+Hd8aF4Dj4bn4/fiT+CP4+/he/DfySQCfoEe4I/IZ4gIqwllBKqCecItwj9hBGiCtGE6EoMJfKIS4lFxAPEJuJNYh9xhKRKMiO5kyJJqaQ1pDJSLekyqZv0lkwmG5JdyPPIQvJqchn5GPkquYf8iaJGsaT4UBIoMspmyiFKM+UB5S2VSjWlelHjqdnUzdQq6kXqE+pHJZqSjRJbiae0SqlCqV7pltIrZaKyiTJLeaFyrnKp8gnlm8ovVYgqpio+KhyVlSoVKqdVulSGVWmqdqqhqhmqG1WrVa+pDqjh1UzV/NR4anlq+9UuqvXSEJoRzYfGpa2jHaBdpvWp49TN1NnqqeqF6kfV29WHNNQ0ZmlEayzRqNA4qyGnI3RTOpueTi+iH6ffo3+epjuNNY0/bcO02mm3pn3QnK7ppcnXLNCs07yr+VmLoeWnlaa1VatB67E2RttSe572Yu092pe1X05Xn+42nTu9YPrx6Q91YB1LnXCdZTr7ddp0hnX1dAN0xbo7dS/qvtSj63nppeqV6J3TG9Sn6XvoC/VL9M/rP2doMFiMdEYZ4xJjyEDHINBAZrDPoN1gxNDMMMpwrWGd4WMjkhHTKNmoxKjFaMhY33iO8XLjGuOHJkQTponAZIdJq8kHUzPTGNP1pg2mA2aaZmyzXLMas25zqrmneZZ5pfkdC5wF0yLNYrdFhyVs6WgpsKywvGkFWzlZCa12W3XOwM5wmSGaUTmjy5pizbLOsa6x7rGh24TYrLVpsHk103hm/MytM1tnfrN1tE23PWD7yE7NLshurV2T3Rt7S3uufYX9HQeqg7/DKodGh9ezrGbxZ+2Zdd+R5jjHcb1ji+NXJ2cniVOt06CzsXOi8y7nLqY6M4y5kXnVBevi7bLK5YzLJ1cn12zX465/uFm7pblVuw3MNpvNn31gdq+7oTvHfZ+73IPhkejxg4fc08CT41np+dTLyIvnddCrn2XBSmUdYb3ytvWWeJ/y/uDj6rPCp9kX8Q3wLfBt91Pzi/Ir93vib+if4l/jPxTgGLAsoDkQGxgcuDWwi63L5rKr2ENBzkErgi4FU4IjgsuDn4ZYhkhCmubAc4LmbJvTPddkrmhuQygIZYduC30cZhaWFfbzPNy8sHkV856F24UvD2+NoEUsiqiOeB/pHVkU+SjKPEoW1RKtHJ0QXRX9IcY3pjhGHjszdkXsjTjtOGFcYzw+Pjr+YPzwfL/52+f3JTgm5CfcW2C2YMmCawu1F6YvPLtIeRFn0YlEbGJMYnXiF04op5IznMRO2pU0xPXh7uC+4HnxSniDfHd+Mb8/2T25OHkgxT1lW8qgwFNQKngp9BGWC1+nBqbuTf2QFpp2KG00PSa9LoOQkZhxWqQmShNdytTLXJLZKbYS54vlWa5Z27OGJMGSg1JIukDamK2OiqM2mbnsO1lPjkdORc7HxdGLTyxRXSJa0rbUcumGpf25/rk/LsMs4y5rWW6wfM3ynhWsFftWQiuTVrasMlqVt6pvdcDqw2tIa9LW/LLWdm3x2nfrYtY15enmrc7r/S7gu5p8pXxJftd6t/V7v8d8L/y+fYPDhp0bvhXwCq4X2haWFn7ZyN14fZPdprJNo5uTN7cXORXt2YLbItpyb6vn1sPFqsW5xb3b5myrL2GUFJS8275o+7XSWaV7d5B2yHbIy0LKGnca79yy80u5oPxuhXdF3S6dXRt2fdjN231rj9ee2r26ewv3fv5B+MP9fQH76itNK0v34/bn7H92IPpA64/MH6sOah8sPPj1kOiQ/HD44UtVzlVV1TrVRTVwjaxm8EjCkY6jvkcba61r99XR6wqPgWOyY89/Svzp3vHg4y0nmCdqT5qc3HWKdqqgHqpfWj/UIGiQN8Y1dp4OOt3S5NZ06mebnw+dMThTcVbjbNE50rm8c6Pnc88PN4ubX15IudDbsqjl0cXYi3cuzbvUfjn48tUr/lcutrJaz191v3rmmuu109eZ1xtuON2ob3NsO/WL4y+n2p3a628632zscOlo6pzdee6W560Lt31vX7nDvnPj7ty7nfei7t3vSuiS3+fdH3iQ/uD1w5yHI49Wd2O7Cx6rPC59ovOk8leLX+vkTvKzPb49bU8jnj7q5fa++E3625e+vGfUZ6X9+v1VA/YDZwb9Bzuez3/e90L8YuRl/u+qv+96Zf7q5B9ef7QNxQ71vZa8Hn2z8a3W20PvZr1rGQ4bfvI+4/3Ih4KPWh8Pf2J+av0c87l/ZPEX/JeyrxZfm74Ff+sezRgdFXMknHEpgKADTk4G4M0hVBPHAUDrAIA0f0JTjxs08R0wTuA/8YTuHjcnAPY3AxC5GoAQ1O9EvSk6lL0AGJNCkV4AdnBQjH+ZNNnBfqIWBVWU2I+jo291AcA3AfBVMjo6snt09Cv6zYCg2qY5a0LLj8tjGgBmAFUZkLz6PPinTej8v+zxnx4oOvib/xNN/xTCVYdpSwAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAA0g2oaAAAh40lEQVR4Ae1dB3xU1dKfuxsSILQAoUpLo0mREhAVUd9TsCAK+Oxd/ER5FpKIis98YkFIKKLoAwX1PdTP7rNgBQnKk4QgIGh6aCJFSID0ZPd+/1nYsGx277l39967m7jz+yV795Q5c86dPWfOnJk5Ev3Jod+sn3rLdTUxMkmxMlEPSaL2kixHyRK1k2QpCmlRSGuHYepycqj2yzKVSkQlsiSXSHiWJakEaUeQtkciuVAKCy/KmXvWzj/z0GIsmjZET9/RqkPryj6yTQbz2GNJkmLQ6ViSKYYk6o3ehxs0AjVoYycYsxDtFJEsF0lkKZSsUtGxFlS4L3VEhUHtBgXapslYqbIlrjx7qFWWx8okj8VIn4dZp2MwjDhmtj9ARwboybATrcufP3IrEea9JgZNg7GmytbYHlmjrFYai1kCjCSfI0lSm8bxruQSMNZ6LL0ZWEbX5RYn/kTvSrbGQbt3Khs9Y8Umbe1klWruJNl+J5ipj/euBn+OLMvFYLLlNop4tTBtyMHgp9g7hY2UsWQpbmbmxRZJmiZJ8kS8jDDvXWyMOXId+vSxjSzLCuYP/xrPjW6pbFSMFTcjP8LSovQWyS7PhECc0BhZRjPNMuWBq9Ls1VFvFCyJr9ZcP0AVGgVj9Zy1LaqFrepeLBUzsNx1CtBYBbRZbEIOQPBfUh3WYunuuYMhlwU3BDVj9Zm5uVczS+1M6JNuxwwVGdxDaRJ1MpWjpVdr5LAFxenDdpnUquZmgpKxuqVuatmq3P4kdkn3Nz35SfM78lIBcphMC4+3sqYGo04s6Bgrfmbm1RYLLcRo9vQyoqHk00dgN04A7s+bN+qj05MD+y1oGCvhwawYstqXQ4a6MLBD0jhbh/y5hmyWu/IWjiwKhh4EnLF42Ysss88CISnQRkcEw6A0Vhog3FdDFn3OXhX1TKB3kAFlrNiHMntAW/4eiEhsrC8zGOmGeiLTZqMphQsS9wSKvoAxFmSpsRZJ/hCHwu0D1fkm3a4sH7HL0lX56YkZgeinxfxGZSkhOXMWNOZrQkxl4OjjB8tj3Dd5YwrOTk2fQExtkE1YolqWvwNZaoKBQxpC7TYCkL1Wl1REXnNo6cAytyzDvprGWLFJWWeGSfYPoJeKN6w3IcQKIyDn18mWqwvTRm5XKKRblimMFTsze7jVYluNxqJ1ozyESPMIQKg/ZLNbJxSmD8/WXFljBcMZq29y5njQ9D7+WmqkLVTcmBGosNtpgtFCvaHCe3xS5m1Q3H0aYipjOMRHrC0h434VNzNrio/1VVUzjLESkjamWiRaAU26VRUloUKmjQAroqHqeQerCc5ijQFDGIuZCgz1hDEkh7DqMQJgLhaDFvG70gOfOw7dZaz4pKy78Wt42b2h0PfgHQHZTvfmpScu1ZNCXRkrISnrWljRrgJSQ2ZCPTsewnVqBLBbtGMGuzl3XuKqU6n+PenGWPFJGy+DTAXTjaZmf+7fADee2rDvkqwX584bsVYPmnVhrL4pG0dAu7sey3ZzPYgK4QjUCMjHZbt0EZbFLH8p8HvJipv54wAcRX0RYip/X0Uw1JdaSxZaHfdw5kB/qfGPsVLXhlkl6Q0Q0cFfQkL1g2YEOlhstJLwbv2hyC/G6lsemQYLheH+EBCqG3wjAEF+pOPd+kGaz8rL+OSNl2P5W+xH26ZWbd3cSleNiKanp/Smhy/vSb+X1lDu75WG0nDViI700QMD6eJB7cmOrdeew1VUXYeHxgGjO5477afDPyzP9YVcn4T3mIc39Qyz2beCszm8T1DDmPg2NHlkR7ps6Omr9YGjNXT+04jHYSB899gQ6tL29GA2q7ceoY+yD9O6nFIDW9YHNTZkpbVy2FBf3My0MxbW3r5lLX8M9iXw2tGd6LaxnalXR+8b1WGPb6aKamPib7SMsNLmOcO8vuFDx2ppRcZ+Wom/YAYwV1Zeq/IxlHoB3P7Vg2YBLaGs5exgZapWWO6uP7sT3XxuZ+rYupl4FDBqRgF8IhVRR7dphiW5B10Hehes3ktfbDuiWD5QmSxv8TvPI0rVQoOmGSsu5cczLHZLARoLOm+aKYnRlHzpGdS2pfrfyrDZ2VRRgyhVBkBkhIWy56jf12zfU05PfrSLtuEz2AC/v2q7xR5XMG/0XrW0adoVWuzSC8HGVDGdmtOb0/vTUxDKtTAVD5DynKJ2CL2V0/SbpTN7RNI7MwbQ01N7U4twTa/FGwG6pfM753evBaHqHiSkbJwEi4UrtSA3uuy9f+lOnycNomG9W2luimWrSoNmKyamHPh9kd8mj4ymTx46kwaB0YIJ+N2fNNpURZYqxhqYuiMcx5TPq8JoQiGWpZbdnkAzLu7mc2v/t/GQz3XVVnz7R9/aOKN9BL2L2Wv6X3zvn1oatZTDkrjQwQsqKqnSY0WNuOVxcCwCnAUeekc3p3/9Tz8a0lP7LMXU825s0Ze/0dJv9hnemeydZcRLdWznFj61NSq2DZ2T0Ja+2VFK1bXGyIJaCMOS2NFWU2M/vOGV70T1hIJAzEMbE8Is0rZgkK14kJ+/KZYisZXXCr/uq6DXMg7Qx5s5tqy50C0qgq4bHU1TR0VTOw2bCyeVxYeq6I5X8mhfSeDjrqkV5IWMhXV1ETpomAmrc/BEn6zFfvaaPqJiDfKzi487ZqisouMN8gKRwP2YOeEMdeoQFwIPl9XSnWAu/oEEASzOnZ/4gBIdiozVOzmzSzjHJ5ck3+ZypZY15N1zUTe6/5LuGmoQ5e2vdOiHvvs1+DTczZtZ6O4Lu0KB24X4WS1U1tho+msF9N+CY2qrGFIODjKVNYiXv3N+olftrmKvwmXpgUAz1RNX9dLMVE98sIsmLthOwchU/KarIC8thpw3Yf7P9KMGJmkRbqWV0/oSy16BBOYJ5g0lGrzOWDgPbIvzwJ2QrdopITAyb9oFXekhLBtqIe/3CprxRgHtOqyfLNId8lF37NJcIWdfOR2r1OcoCONLN57TmZKg3I0IU/yd15NQVmWjqUt+IZa9AgWQtUrrrJbeRc+NOOqJBq9q6jCb7UFwZsCY6pLB7TUx1evr99Ozn+zx1Eef0+ZA6ToVGn1P8Pd/FdJXP/t/DIMXRP/6/gBl5BylF2+JozgVO0hWt7x+dz+6Bsy1H4fpgQCecJhH0Haqp/Y9zliBnq2G9Ix0qBTCVfyCsd7TP97fSe9m6rvb69ounNY+OsTTmDnSdmK2GI+lTE9oCY37C2CuMfFtVaEtOljpmLnKqwOjilCatTzOvVa7/apALYFRkWG09NZ4UsNUPPopbxfrzlSMt2eH05c/TnMF9+XRNc/XZz63vH15HvHsqwZiOrWA+iVOTVFDyjCPMK94Qu6RsZB4q6fCZqTN/Vsf6tBKhWUCiLn39QL65KfDZpBlahu8pL/wtToFLuv2/gYToUCBN15pwFiO+/scFx2ZT+oNYzrR+f3EYp0N5pjTXs2jb3eUmE+kSS2+8PVvtGLd76pae/SKHtQNS3cgAMvh2LhHNjcQRBswlt1Wey2mOI+yl5GEx2JaT4F9khrg5S8j1+NmRE31RlNm3md7VS2LEdCFpV0fG5B+Ma9Ya203uDfegLFwYeO17oXM+M76KjXb7UffLabPtjS95c/bGPOyqEYfxxYed47r6g2Noem4YPRW9wZOY6z45MyhUDF43wq519bp+18GRlFibGshNrZI+CBL392fsNEgKPDQqkLaDUcMEcz4azfq3FadfCrCpSWfeYZ5x7XOaae50efcNQuZo10LmPG87I4EatPCq0rNQcKuP6ocwnodu7sYBJef1cFh1szHLbfiuAVOk15bsiKeQA/sHDu1CadaG65NPV7rtay/GYx/Q/5xh1OIEk2cx95Ia34p9bdJ7fVl6ejhDcu/cVY87W1CJzQO3OfMM+XzDkzfbH8kgvugUeejEL2hPdQbfBY5CYfD/FK0wJXDOhL/MbA2nC0n0j7fa4gBYSF0VumwjX9sYk9FEtlEeyWsOLi8uWAfj/Z4YnJA/VLISlEE9BjszDDr847zuwibYvupfBwq6w13X9iN1kAJehOcL7QylTstrA2/YUxnWp08iIb3ES/r7vXVfGcNvRqb+Jk4HjIdJGkQX//nbLeescJk2wVm7wavgX0SzxhKcPBYDb36nbpttxIe9zzWcD84vrsm6wJ3HJ6+sx/hqnv6wXrBGOvPx94ppjosjUpw4YB2PplrK+EU5WGdszS3V57vLFfPWLgTcJwz0axPPmQWAe+KWMbQE16DhQBvGIwEZlotB+hqack/UElv/ld8XbSasVXbptpyrjxUz1iozGukacC/KpFstXV3GbHnsJ6Qfn0MjY4zx+yEX663Q2x/+vQilKfHK5X9R8f2bUvRanwr/SHErS7L6M4kh7TK2nbcAj/HmWjG56wrelJvBS9lpuHx93Zim62fCQybp2jR9WyC9enHmw/TxsJjlAkLVP5jkxze3kRjN6gGzgYTf/LTEToO4V4v4PgPFuxKGbc34E0Yt8l9MA1wrXLk2BlLjn7/UpVDwLHZase5Tl1GE8IHzef3Uz7B56Ad63XUrrdpYSXW84iAd3cvr/mdPtz0B7E5sDeI79LCoZoQzUjsI3gfvG1YsasnvL7+gONHorTpYBn2pW/VnTnqQZtDzqqrvgS43nbwE/6dptzSoxElHJcOEV/49b7OitDrzu4sdGhle/LL07fTK9gsKDEV9413qTyj3rosV6mrjryrEZRE7cG6ENnJAqx6+WyLspjApj8cFMVMwMVQDj3oiYlKlvuZ2fjEYR2Ezb2X6ZtPnjfEfz1T+XCblw12VtBqOMemxY9gpyaCCSp+TCIc7vkfZInH6Gro50yFk7zkXAFNYywOhiHyCdyQf0zzC1YaPHa9P/OMSKUixIwsmqW8IeBlc8fecm/ZjvRzE/SfOVinJVKEngsh3mRw8JKFr86VJUmdWYEOFCbGiJWHepj8upKqZne0qbjMtYrm58Vf/aZYp29XY64SEi2H7MfYr5sxbXvqMBRDZ/RNyWltiSy3J7DQ5amQEWkjBFppNjX+XGcVg5KA6+zj0Qrl7buznLdPtln/XmGz8alBBolqbNJGm+jVg92o1S4fiw2DUqsfgv57Gy/d0xMFnczCzKGXB4yTeDW94yMZf+FOGB+OxIzsft5qx8G5Udt+Dnd5EA4VndwiB7r25WwI8K+pNHd2refrM/MU1A12rImsmTEeWM0Qi1gGSvBDnv7OmKXl4tmob9cWquyelGjnvEB4XH+1vcThQuaNtrN6KcuX3ur5nm7vZ4EezTT5So1r0/a9/sk6ngajpNy7PspZftLwjgSdY6OE7XuV3e7ZJElVhEOdes88ZZFJMo2dRZp27teWXfoz1lE4l4p2fH0QxYZPAxoj/PKb8o6U+xSD/pkFzFO4qEtWVvDoSI1SoFluho9vjPKRW/er2EaeY5e+fFu80PVLxyHRBRUfTNfalG3V+IdjFjBPYcYyz4W+V0dlg75CDJBRsD5PzFjc9rj+7eirhwfTohtjHSG82cU+2AEbaSo8UKVIZh+BbKtYWWMm81QYdjCmzVgiFyW2vTIK2EriblgbqNXpjIeLP/8xHIHwn4u4EL/+VkF7jlTTXvz9hlhVRQeVX6ZRffGEV2Qa3Vnlobkn3D6kNQ+DV05z7I99qKu9Csc+V4IDiLZnJDz23k56/+8DNDfBxohsSeDJmoDjb62DDos9aTh0UqDgcJnyzlcPdYravmGyam6RJTJt8W2JMDxKwLdFGAl87HLnK7lUU6csj2ihgc2Q2aDvPwhI+2XKIPr7xd2Jw1maDX8oWGIwLWYylkyQsXAlnGlLYYtw5ZmxzITgFt9DTzYdrvl6K2H55fHmhAPSfgG79/nXxRDr7cwCUX9aCVYLXekET5l2lMOEi1y8WAg1A/jo5ZJ52wyN+3AFXMm+TBlMbCkbDGDmjMX9teA4p9Ssjott103iLHS4BAJ58ltFdFnadnoZxnAskOsNbFy45OY4UmN/5m/bIuUux7swDcBTOCukKpNOdBymsiKvHNM6f7IhNjth9zL+G9C9pSMoCc8yegXwZ8fWBTfEOhg5kLFD+UIDs4B5Kgw7QtP2zHxTgxJjqbFCMHJwfoE6gf/YnJeDzrKzx4lQkeEOpSnbdA2ACYpod+uJxscn9aJL0/QN1Obajmipq6o1c8aSqsJgplLqfhrvSrCez2xPrgRmnmcp0cF5bPpbAIUt/7kD21YN79OKJsM6c6DAgNBZly8SYPv4d3W2jHXi76xg3cBlOOKyWcA8xUuzaTKWyFNFb7twowaSlaVvbjhIk5//hW56OQeznPisjmkxwjzZ2cfOsMxVAtHYK9XVmsc8xUc6pi2FrK1WgmCasZTodM1jMxlmsM+3ikMrjUJEHb5uzgjoJGCsPTq60Ynoh0VyKXopmeZ4JgofrcasRtSpQOSzmoR3mJ6WTVd6WJAX2d67llf7HB4GOxVBYBU1YZDUticqh0tAy8FYcqGooF75QsaCHIJ7e/RqzlQ8bFywbK04xoQRs/LgHq0cDqxKHRaNvVJdrXn4oe2BatiSY/SVkE7CRIe27N3LW341EVWcONV88o6JdUkNlwuJVm044FAFqMEjKqPGIaO9ysC9orZc84f2Et+EtusPZTHEFZ//z5acMFmSc8yaI0RLBXdoEH59ejMWHzx7swW7aGA7umrRDv/HEhjU3M4lOi/1hRCOi68EpXAU0eovqYRPlMc8hUmiTSG2h6btRUVKwnH99fWD47im3piKB6g/9FJjBe7+ooF05rOmXQRHBIfFovqe8kcLwmxmFpomRvN1yPbySEueJXdev+OYsfZ6ItiItPUwMVECdgnXciOWEi7Oq4Ylg8ip8xyd3NDju4j99/SeOXi2ai0Is2mUh5CnsYf16J59qSMqnHtfyFnmwPcCS07eObEVp56wbbeynonDK/pyuaY7jRMGi2NucWgmPYEvEBCByZ5DDl46wViSZBpjsTHcQYFB3xVniYOGiAbTNf+rn0tcvzZ4ZqbSeh+iO5JeCHTL0V2UYDOu8hWZtyjV95R3roCx2BHX1MszT/KSg7GwU97iiWij0r7erhwl5SJE2xMdUWihbS2sO0VxttiRgmcuX4B3mxz5WXT/j97Xs7CDBMd3VwK9vcqV2uI8Jy85GKvOHraWhS5RJb3yOYiGCES/flF99/wlgtgKXP6pKb0dlgiiSIOuuK87uxN9AutRpQ0Cl+d4X2+pCPHoilv0zIHkRKA3Myu1B/2VbLfRt1ymXtOQkLRxCw6jhyhV1DPv05lnKt7Nx7fNn/eUvhPpm9P7C3/hzj7yC9myq9xhp3UATh5sNl0BC1c2O2bG64eD6CmJHYljUKmBJGjm9YzfwJYg6x8fqrjRYWa+4JmtasjTpQy0C1vz0kYNZWT1trNgqu/w3TTG4vsFH8HlQt6Awx3xbKDnrzzpzUJ6Z8YAVV7BbAHKf3oAM5SeTMU0XT0yWpGpuMzH2eKVgcvpBSd5yIHOuSuE6bv8nV4NqMHzHwTbFzlZ3nNRV2qmcDuEmnZcy+zDL/julfmYeUxT2xF78fBspSe0xEH2dIyNEnDIbjXRlZVwaM1z5aF6xqqytFhnppzFpsFrBVdz8HUiet/Fx546N7yUo9sxjtLgZ+SUqgolqYTDU969uEmDg8kpAQvtot23Un2teSxf1UnWtc569Yy1e+7gEvgYGmfi6GzR5XOJisse74XXS7uWYo22C1rhI2+/r1/6K+Xg0whgM2C+nmTainzdY9SzTHfzeWKhneOomgvyNteLx+sZi4mA3+qXZhLDAWJFV8SxC9WjE3vpThaf9k/CGeHDuPtQr+tUWMu/MmM/BOZttFyFpYMvnZozuTfEg9NeWwM0HGrTbOdZd945bT61k/QWSE5pQKmBCQvwy2ZXdta4ewMOhssXIBkRO4vx8h/rzVjjf3Zca0fwNC3WrHzxOMeoenXdfvI3MqC3MeD0a0dHk5qYoou+MO2Erp5c5p36L3ho8DbNVjswMY9P6um44MiVMPdn3jrzDGPki3Ntk9UK7HiqBLPhsq93dGdv7fENtO/fP0C4E+Tdp96bBW80OdNd1QzOtAZzqkSW15yZZn3yxdqVuMFdCVi2WIwIMGYBz0IiVzwuYxZw9BvR4TwvxXytndngiWcaMJatmXUVS/hmEsc7xCc/2iVsku/AUXtvtBBZIyrATMU3YYhg+dr9ptpdMT3MK7Is/dudtgaMVfDssEMQxDLcCxr9nY951FzIdDtuPhVdM2I0rWbi51vEnOGUlNplI0qjNgxK7TKv5KWPaKCJbcBYjASL0mtKyIzKm/1eMc7UxCa0T07uRWputzCKTrPwTsZVKWruPeToOQ/+u9Bhe2YWbc52vPGKR8aSq+wfYIordVY265PDRCa9VSxsjh1s510bQ3yHc1OFyTiyeXpqH1Xdm/fZXuJwkWYD8wjziqd2PTJWwZLRiIktL/ZUweg0PgJh5aIaSEOooFvP66KmqE9lFDQgDnx2jKwRwPG2np7aWxVqvrjg3z8cUFVW/0Ly4hO80hCzR8biYnVW68JAzFrcNssKakxruOwsHGQ/g5cgYgIuqxWYyb0B72JzELxfT2D/wOdviiO1t6MWIaDJg6sK9CRBNS7mDeYRbxW8npWU/LCsusOYaVFYdc71VtnI9G93lDqcO9VEx+vfPdJxwff63GNCtYUWmr8BDREIDlKDiyf3ldTU/3HIo1m48UtP72K251pxZ18apXC5pSvt7Hlzw0u5dEQQItK1jr7P8nMF8xO9ntQ0UJC6Nt47ObNLuCwXQaYR73VdK+r0HIFf8Jv39qeBYBw1wGqLf7xfTF9vN108VEOe1zLXj+lEKZf1EOqpnAg4YMn1L/5Kvxh01ulsx9sn9AuVmK26up4Nupf1OmNxwdINy8s6njON7XVHu1c04zt7F3+Do5JxiFfVPlI56AXTw7eZXjqkA/WA/XlmYVlAdklaxoVvvE/DHdW3QE4MU2kexCY/018roJ8MuGhBLe2YaJYWzBv5sVJ5xRmLK/Z6YFPXiDBbYaBmLaaBPZmXw6b8LBUev1yegY9+2HqCDQVNjWZ3onnF/2xjdhv0cffA/IV/DGqBfRJvX56ru2yntn0ux7NVdZ01dteiEYrmE4ozFiM6+uOysg5j7moGxhrH3wMBLOPwVb4coz0GZ2ZqgI8/2BF1PFyy+JzRzOMXJfr4oHvpLfGOkEZajBh3/VFFN0KmMjMGg5d+PFO0IPFTL3n1ycIZi0sOTN0RXltWXgBB3rstcT1KYx9Sr+6FU/5Omhthtyu+2+9rLK1rBAaGmpGrqMAeQLfAE0jN0Yw7OvYLvO+NAtMO4N3bd/meGxYZOXhH6kBh3HRVjMWIE1I2TsI9dB+6NBKwR/ZOmX1lT5/b5xgLty3PI54FjIbbz+9Cd+BPixmOK018z+DcT/a4JgXyeULu/MQv1BCgmrEYGUxqPsKSeKUaxEaX4e35QgSN5eg0vgC7nd8IE2Uj4YmrejkcQnxt47F3cZOGigvFfcWvpR5kq4/hgTNJbR31kiMw2i3yfVCMiQ/z1LbuRzmeba5evIP+uWafT1hEVwj7hNStEnsZ+QIca4KjBAYPU1E1v3stfdHEWAXzRuOsRZ6rpQGjyy784jeHc4Qo9pYnOnyJfuwJj6c0URRjT3VYPzXvsz2O2PPs9BE8IM898e7VU6SJsRhtXquKpzBrZalvwviSfPTCoa4fgTbcTM8UpZ5hjDQBbygmzP+ZVsC8OahAlrP5nWulSZOM5UTeZ+bmXs2kOnhOm3fXobNt0SfHw7oFXix34Qo5Udz4YbOzqUJguSpqz1s+B7HNnjPcW7YjnfVrn2054ggxqSYonSIyAzJPnAdahkDDvlsrep8Yixvpm5I1EdoyRe2rVmL0LN8Ofne8xb8Sjhjetvj9UoybeHmZ3TxnmMcusfb8482HHQzFOrZgBTvJV+TPHyXUWXmi32fGYmR9kzMX4eN+T4iDKY0jFV+O0EjsMu/c9n+x7Qg9AOM4IyFj9tDT4p7yTpQVvWwpy/JUkMNiqBYe8JVGvxiLUteGJZRFbsCSONJXAsyud/Gg9hSL6Mx81MMWAkbCkJ6tHNfLrfmlBO0dMkVvpkt/IFfltqoYTakX+DxA/jEWetFv1k+95bqabHi76hstTZcRCiHRPAKyfKRGbjasOH3YLs11XSpo3hW61HU85sw9aye8NMbDWcN4NbZ746Hvuo6A4x1a6BJ/mYqJ8puxGEleemKWXZaugY7L56mT8YQgkCMg12EXOCV33qhNelChC2MxIQVpiZ9gObwV6pugl0r1GLimhIPfmSxbbspPG/WZXv3SjbGYoNx5iavAVjP0Ii6Ex5wRgCgzPS9t5Nt6tqYrYzFhWBaX4sDyf/UkMoTLuBHAbPVIftrIf+rdgu6MxQTiFDwVBD+hN7EhfPqOAE8AefMTDTn79VvdoNTV+KTM23DF2HKY2ggtVZXwhPL0HQEwFAJJSnflpyWu1BfzKWyGMhY3A+38eHy8jz/fDKcYSQj0HIEKIJus1mDP14YNZywmLHZm9nCrxbYajbHHTwgCNAIQTw7Z7NYJhenDs40mwRAZy51o7oidLGdDz5Xvnhf6bs4IQEeVw+/ADKbiHpkyYzmHLnr6jlZRLcvfwdniBGda6NP4EQBTrS6piLzm0NKBZca3dqIFUxnrRJOyBLkrGZ19JiTUG/uaWUiH0np23vyRz2EOwUpoHgSAsU50Ln5m5liLJH8YOrw27GXvt9vpb/npiRmGtaCAOGCMxTTFPpTZw2ql90BEogKNoSyNI4CpKbO2xj6xePHoAxqr6lY8oIzl7AX0XU8iDNHjzu+hT99HANbOc6Cf+ofvGPSpGRSMxV1JeDArhqx2VqZeqE/X/lxYIE+tIZvlrryFI4uCoedBw1jOwYhP2ni9RZLS8b2LMy30qTgCuyFLPQhZymPIRsWaBmaaosfSQj9MN960Vdn7wlFjfsi+S2nkYD9FlH480tI/2JiKqQ66Gct1KNnNLFyqewhpd4BSddHXXBE0xWeZynF924pae7N0PSw9jRqioGYsZ6d7ztoWFVFXOR2K1RkSSeKrr5wVm9AnZKiDkD+XVFqbv+i4qS3I+9YoGMs5hnEz8iMsESU3g+gkzGAJzvQm/SlTnmyR0u2V7V4vWBIfFHEz1Ix3o2KsUx2Spbjk7L9ayT4Nchii30hhp/KawhPbn0v/gb3wsoL0xK/M1prrMYKNlLFOdT02aWsnK1XfAQa7C0tFn1M5je8Jy10xSZZXbHL4K4VpQw42vh6corjRM9aprhDFJW+62CLbWdC/BB1r65oXrM/Y2R3FlVhfYnZaUZA+6stgpVMrXU2KsU51Xpbik7OGQJdyPg67xyJ9LAT/jqfyA/cEevhCo/WgZ53NJmUULBixpTEudaIRbKKM1bDbcQ9nDrTaaSxe7Jl4qTFYOmPxQuMbltQzBfZnMhXBDBhRp2m7zUIZBc8l7tCzhWDF9adhLG8v4GSIgBi8/FgsSz3AAO0lWY6SEaIJMVejkMa3c7RDfedJwH4wZykGrgT6pBIYo5TKklSCtCNI2wMb/0IpLLyIPcS9tflnSP9/m89gtSHst58AAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

const CircleIcon = (props: any) => {
  const { width, height, className, ...rest } = props;
  return (
    <svg
      className={className}
      {...rest}
      width={width || '5'}
      height={height || '5'}
      viewBox="0 0 5 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="currentColor" />
    </svg>
  );
};
export const CircleIconLarge = (props: any) => {
  const { width, height, className } = props;
  return (
    <svg
      {...props}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill="currentColor" />
    </svg>
  );
};
const WNEARExchangeIcon = (props: any) => {
  const { width, height, className } = props;
  const [hover, setHover] = useState(false);

  const isMobile = useClientMobile();

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="xs:ml-1"
    >
      <span className={!isMobile ? 'hidden' : ''}>
        <WrapNearMobile />
      </span>
      {isMobile ? null : hover ? <WrapNearDefault /> : <WrapNearHover />}
    </div>
  );
};

export const MappingAccountIcon = () => {
  const Unit = () => {
    return (
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="-0.707107"
          y="8"
          width="11.3615"
          height="11.3615"
          rx="3.5"
          transform="rotate(-45 -0.707107 8)"
          stroke="currentColor"
        />
      </svg>
    );
  };

  return (
    <div className="w-5 flex items-center justify-end">
      <div
        style={{
          position: 'relative',
          left: '10px',
        }}
      >
        <Unit />
      </div>

      <div>
        <Unit />
      </div>
    </div>
  );
};
export const ArcIcon = () => {
  return (
    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDUzNTI1MDdCQTJDMTFFQ0E3OTRGREEwQTRFNTg2NkMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDUzNTI1MDhCQTJDMTFFQ0E3OTRGREEwQTRFNTg2NkMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENTM1MjUwNUJBMkMxMUVDQTc5NEZEQTBBNEU1ODY2QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpENTM1MjUwNkJBMkMxMUVDQTc5NEZEQTBBNEU1ODY2QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnwWoIsAAAHnSURBVHjahFKxbhNBEN3Zu0suMb61FTvRgUNcXIMcpYjbFG7T0bilzhdQQOOeH+AP+APSWKKiNAVBQkJGOIkTR7EJd7ZlC3J7w+xxd1osG1Yazezp5u289wYYY1sUIYVMIkpC1ZjEysPF9rYoFovpHdLcbDYhucO/AExrzdkd3Xbv0h89z2NCCBwOh6C9Dqsm4aa9sU8N2Wvdbhc6nQ7oEyGuZsEtkx8FQZA1VCqVGGgymcS51WoBndUAjBnHYmdPFAoFrhr6/T5Uq9V4ikajoWuzXI/dJ4foegcviIZSUlA8oNgkELter1tUG38eYjylolMCBUDXi/7nD4ealbqdmGaiEzdRRgVC1DAGUB8jGb68+vLxtWoulUqRZVnSMAwkSvo+6HuhMpiZGNx8Xni4d+pfn59LKdloNGKu68qEQkR01BSQz+exXC5jrVZTk4Ahym4rkcleszeO+bp96t/eBOrTdDrNrBwMBpDL5WJH2u12LGiv14OMQnqI2qef4+/P7mfBN9/3cUELpEVTNaN9wUzERWeQ4cU0uHuq6CwCaDUjp5AvWw5g8DjvbL175B2cJBoYmp1ZPZ/PjaUTLE4T/gpf3Xw9e+M4Do7H478c+S+ABhWQ92+jUL5HGZ7NZrNLnP8IfgswAO2T27xIUwP9AAAAAElFTkSuQmCC"></img>
  );
};

const GoodIcon = () => {
  return (
    <div className="relative">
      <div className="absolute">
        <GoodBg />
      </div>

      <div className="relative top-0.5 left-0.5">
        <GoodThumb />
      </div>
    </div>
  );
};

export const AddButtonIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.2 7.55002C3.2 7.96424 3.53579 8.30002 3.95 8.30002C4.36421 8.30002 4.7 7.96424 4.7 7.55002V4.90002H7.55C7.96421 4.90002 8.3 4.56424 8.3 4.15002C8.3 3.73581 7.96421 3.40002 7.55 3.40002H4.7V0.750023C4.7 0.335809 4.36421 2.28882e-05 3.95 2.28882e-05C3.53579 2.28882e-05 3.2 0.335809 3.2 0.750023V3.40002H0.75C0.335786 3.40002 0 3.73581 0 4.15002C0 4.56424 0.335786 4.90002 0.75 4.90002H3.2V7.55002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MoreButtonIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="13"
      height="3"
      viewBox="0 0 13 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
      <circle cx="6.5" cy="1.5" r="1.5" fill="currentColor" />
      <circle cx="11.5" cy="1.5" r="1.5" fill="currentColor" />
    </svg>
  );
};

export const SelectedButtonIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="#00C6A2" stroke="#1D2932" />
      <path
        d="M6 10.5L8.66667 13L14 8"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SetButtonIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2088 7.49638C20.0899 6.86833 19.7047 6.4622 19.2113 6.4622H19.1258C17.7926 6.4622 16.7082 5.37785 16.7082 4.04428C16.7082 3.623 16.9104 3.14264 16.9182 3.12354C17.1641 2.57005 16.9754 1.89178 16.4778 1.54365L13.9761 0.150736L13.9393 0.132739C13.4389 -0.0842961 12.7539 0.0546192 12.3807 0.443398C12.1106 0.721927 11.1796 1.51611 10.4692 1.51611C9.74958 1.51611 8.8165 0.705998 8.54508 0.422185C8.17255 0.0305651 7.49463 -0.116451 6.98849 0.10021L4.39776 1.51965L4.35887 1.5444C3.86122 1.89113 3.67177 2.56938 3.91638 3.12075C3.92483 3.14092 4.12773 3.61736 4.12773 4.0443C4.12773 5.37787 3.04335 6.46222 1.71018 6.46222H1.60911C1.13124 6.46222 0.745976 6.86833 0.627227 7.4964C0.618378 7.54059 0.417969 8.60341 0.417969 9.45557C0.417969 10.3066 0.618378 11.3691 0.627227 11.4129C0.745976 12.0414 1.13124 12.4478 1.62464 12.4478H1.71018C3.04335 12.4478 4.12773 13.5322 4.12773 14.8654C4.12773 15.2895 3.92485 15.7681 3.91708 15.7865C3.6718 16.341 3.85984 17.0182 4.35606 17.3646L6.81037 18.7416L6.84783 18.7586C7.35539 18.982 8.04176 18.8364 8.41289 18.4306C8.75571 18.0602 9.68459 17.2911 10.3667 17.2911C11.1061 17.2911 12.0583 18.1521 12.3326 18.4546C12.5856 18.7317 12.9744 18.8986 13.3724 18.8986C13.5583 18.8986 13.7343 18.8618 13.8955 18.7925L16.4403 17.3901L16.4778 17.366C16.9754 17.0182 17.1649 16.341 16.9196 15.7893C16.9111 15.7688 16.7082 15.2923 16.7082 14.8654C16.7082 13.5323 17.7926 12.4479 19.1258 12.4479H19.2255C19.704 12.4479 20.09 12.0414 20.2088 11.413C20.2172 11.3691 20.418 10.3067 20.418 9.4556C20.418 8.60339 20.2172 7.54057 20.2088 7.49638ZM18.9675 9.45555C18.9675 10.0062 18.8579 10.7138 18.8077 11.0093C16.8079 11.1733 15.2577 12.8444 15.2577 14.8654C15.2577 15.4358 15.4387 15.9823 15.5348 16.2336L13.3639 17.4325C13.2572 17.3208 12.9419 17.0026 12.5129 16.6831C11.7593 16.1247 11.0368 15.8394 10.3667 15.8394C9.70222 15.8394 8.98546 16.1176 8.23544 16.669C7.80848 16.98 7.49747 17.2896 7.38859 17.4041L5.30045 16.235C5.40225 15.9709 5.57828 15.4316 5.57828 14.8654C5.57828 12.8444 4.02807 11.1733 2.02899 11.0093C1.97809 10.7138 1.86852 10.0062 1.86852 9.45555C1.86852 8.9038 1.97809 8.19586 2.02899 7.90038C4.02807 7.73674 5.57828 6.0653 5.57828 4.0443C5.57828 3.47703 5.39731 2.92884 5.30117 2.67788L7.52576 1.45531C7.6226 1.55218 7.93999 1.86284 8.37401 2.17175C9.11343 2.69945 9.81753 2.96666 10.4693 2.96666C11.1146 2.96666 11.8137 2.70441 12.5482 2.18696C12.9858 1.87946 13.3025 1.57304 13.3943 1.48645L15.5355 2.67576C15.4387 2.9253 15.2577 3.47172 15.2577 4.0443C15.2577 6.0653 16.8079 7.73674 18.8077 7.90038C18.8579 8.19654 18.9675 8.90734 18.9675 9.45555Z"
        fill="currentColor"
      />
      <path
        d="M10.3742 5.88397C8.41255 5.88397 6.81641 7.48014 6.81641 9.44176C6.81641 11.4037 8.41257 12.9992 10.3742 12.9992C12.3358 12.9992 13.9319 11.4037 13.9319 9.44176C13.9319 7.48014 12.3358 5.88397 10.3742 5.88397ZM12.4814 9.44176C12.4814 10.6035 11.5363 11.5486 10.3742 11.5486C9.21204 11.5486 8.26763 10.6035 8.26763 9.44176C8.26763 8.28068 9.21204 7.33522 10.3742 7.33522C11.5363 7.33524 12.4814 8.28068 12.4814 9.44176Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ReturnArrowButtonIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.72189 0.26192C8.99145 0.576414 8.95503 1.04989 8.64054 1.31946L2.30489 6.75001L8.64054 12.1806C8.95503 12.4501 8.99145 12.9236 8.72189 13.2381C8.45232 13.5526 7.97884 13.589 7.66435 13.3195L0 6.75001L7.66435 0.180571C7.97884 -0.0889955 8.45232 -0.0525743 8.72189 0.26192Z"
        fill="#7E8A93"
      />
    </svg>
  );
};
export const DeleteButtonIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20ZM10 2.5C14.125 2.5 17.5 5.875 17.5 10C17.5 14.125 14.125 17.5 10 17.5C5.875 17.5 2.5 14.125 2.5 10C2.5 5.875 5.875 2.5 10 2.5ZM7.5 11.25H12.5C13.25 11.25 13.75 10.75 13.75 10C13.75 9.25 13.25 8.75 12.5 8.75H7.5C6.75 8.75 6.25 9.25 6.25 10C6.25 10.75 6.75 11.25 7.5 11.25Z"
        fill="#DE5050"
      />
    </svg>
  );
};

export const PinEmpty = (props: any) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8456 4.08698L7.91342 0.154798C7.80969 0.0510673 7.67404 0 7.53839 0C7.40274 0 7.2671 0.0510673 7.16336 0.154798L4.59244 2.72731C4.39775 2.70497 4.20146 2.6954 4.00517 2.6954C2.837 2.6954 1.66884 3.08 0.70973 3.8492C0.463968 4.04549 0.443222 4.41413 0.666642 4.63755L3.56631 7.53722L0.128839 10.9715C0.087347 11.013 0.0602174 11.0688 0.0554298 11.1279L0.00117087 11.7216C-0.0131918 11.8716 0.106497 11.9992 0.254912 11.9992C0.262891 11.9992 0.27087 11.9992 0.278849 11.9976L0.872507 11.9434C0.931554 11.9386 0.987409 11.9115 1.0289 11.87L4.46637 8.4325L7.36604 11.3322C7.46977 11.4359 7.60542 11.487 7.74106 11.487C7.89586 11.487 8.04906 11.4199 8.15439 11.2891C9.05286 10.1672 9.42629 8.76284 9.27468 7.40476L11.8456 4.83384C12.0515 4.62957 12.0515 4.29444 11.8456 4.08698ZM8.46079 6.59567L8.06981 6.98665L8.13045 7.53562C8.1895 8.07343 8.14641 8.60804 7.99959 9.12669C7.91342 9.4299 7.79532 9.71875 7.64531 9.99164L2.01035 4.35349C2.21622 4.24018 2.43006 4.14443 2.65348 4.06783C3.08755 3.91782 3.54237 3.84282 4.00517 3.84282C4.15837 3.84282 4.31317 3.8508 4.46637 3.86835L5.01534 3.92899L5.40633 3.53801L7.53999 1.40435L10.596 4.46041L8.46079 6.59567Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PinSolid = (props: any) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8456 4.08698L7.91342 0.154798C7.80969 0.0510673 7.67404 0 7.53839 0C7.40274 0 7.2671 0.0510673 7.16336 0.154798L4.59244 2.72731C4.39775 2.70497 4.20146 2.6954 4.00517 2.6954C2.837 2.6954 1.66884 3.08 0.70973 3.8492C0.463968 4.04549 0.444818 4.41413 0.666642 4.63755L3.56631 7.53722L0.128839 10.9715C0.087347 11.013 0.0602174 11.0688 0.0554298 11.1279L0.00117087 11.7216C-0.0131918 11.8716 0.106497 11.9992 0.254912 11.9992C0.262891 11.9992 0.27087 11.9992 0.278849 11.9976L0.872507 11.9434C0.931554 11.9386 0.987409 11.9115 1.0289 11.87L4.46637 8.4325L7.36604 11.3322C7.46977 11.4359 7.60542 11.487 7.74106 11.487C7.89586 11.487 8.04906 11.4199 8.15439 11.2891C9.05286 10.1672 9.42629 8.76284 9.27468 7.40476L11.8456 4.83384C12.0515 4.62957 12.0515 4.29444 11.8456 4.08698Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CommonCloseButton = (props: any) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#91A2AE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7766 5.30247C12.0746 5.00452 12.0746 4.52143 11.7766 4.22347C11.4786 3.92551 10.9956 3.92551 10.6976 4.22347L8.00001 6.92106L5.30247 4.22352C5.00452 3.92556 4.52143 3.92556 4.22347 4.22352C3.92551 4.52148 3.92551 5.00456 4.22347 5.30252L6.92101 8.00006L4.22357 10.6975C3.92561 10.9955 3.92561 11.4785 4.22357 11.7765C4.52153 12.0745 5.00462 12.0745 5.30258 11.7765L8.00001 9.07907L10.6975 11.7766C10.9955 12.0745 11.4785 12.0745 11.7765 11.7766C12.0745 11.4786 12.0745 10.9955 11.7765 10.6975L9.07902 8.00006L11.7766 5.30247Z"
        fill="currentColor"
      />
    </svg>
  );
};

export function SelectTokenCloseButton(props: any) {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#91A2AE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7766 5.30247C12.0746 5.00452 12.0746 4.52143 11.7766 4.22347C11.4786 3.92551 10.9956 3.92551 10.6976 4.22347L8.00001 6.92106L5.30247 4.22352C5.00452 3.92556 4.52143 3.92556 4.22347 4.22352C3.92551 4.52148 3.92551 5.00456 4.22347 5.30252L6.92101 8.00006L4.22357 10.6975C3.92561 10.9955 3.92561 11.4785 4.22357 11.7765C4.52153 12.0745 5.00462 12.0745 5.30258 11.7765L8.00001 9.07907L10.6975 11.7766C10.9955 12.0745 11.4785 12.0745 11.7765 11.7766C12.0745 11.4786 12.0745 10.9955 11.7765 10.6975L9.07902 8.00006L11.7766 5.30247Z"
        fill="black"
      />
    </svg>
  );
}

export function WarnTipIcon(props: any) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="9" fill="#00FFD1" />
      <rect
        x="10"
        y="13"
        width="2"
        height="5"
        transform="rotate(-180 10 13)"
        fill="#18252E"
      />
      <circle cx="9" cy="6" r="1" transform="rotate(-180 9 6)" fill="#18252E" />
    </svg>
  );
}

export function TknIcon(props: any) {
  return (
    <svg
      {...props}
      width="29"
      height="10"
      viewBox="0 0 29 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2929 0C26.2338 5.82596 20.6776 10 14.1465 10C7.61538 10 2.05918 5.82596 0 0H29.2929Z"
        fill="black"
      />
      <path
        d="M6.392 7L7.656 2.312H5.872L6.12 1.4H10.664L10.416 2.312H8.64L7.376 7H6.392ZM10.0973 7L11.6013 1.4H12.5933L11.8333 4.232L15.1133 1.4H16.4653L13.6173 3.792L15.0493 7H13.9613L12.8333 4.376L11.4813 5.512L11.0893 7H10.0973ZM15.8786 7L17.3826 1.4H18.2946L20.1906 5.36L21.2626 1.4H22.2306L20.7266 7H19.9026L17.9426 2.928L16.8546 7H15.8786Z"
        fill="white"
      />
    </svg>
  );
}

export {
  AccountIcon,
  WalletIcon,
  NearIcon,
  RefIcon,
  CircleIcon,
  WNEARExchangeIcon,
  GoodIcon,
  RateExchangeMobile,
  USDCWIcon,
};

export const PolygonRight = () => {
  return <PolygonRightSvg />;
};

export function SpinLoading({
  className = 'animate-spin top-1/2 absolute left-1/2',
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      className={className}
      style={{
        zIndex: 299,
      }}
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 3C8.14348 3 6.36301 3.7375 5.05025 5.05025C3.7375 6.36301 3 8.14348 3 10C3 11.8565 3.7375 13.637 5.05025 14.9497C6.36301 16.2625 8.14348 17 10 17C11.8565 17 13.637 16.2625 14.9497 14.9497C16.2625 13.637 17 11.8565 17 10C17 8.14348 16.2625 6.36301 14.9497 5.05025C13.637 3.7375 11.8565 3 10 3Z"
        fill="#7E8A93"
        fillOpacity="0.2"
      />
      <path
        d="M17.0709 17.071C20.9759 13.166 20.9759 6.83399 17.0709 2.92899C13.1659 -0.976006 6.83388 -0.976006 2.92888 2.92899C2.65564 3.2119 2.50445 3.5908 2.50787 3.9841C2.51129 4.37739 2.66904 4.75361 2.94715 5.03172C3.22526 5.30983 3.60148 5.46759 3.99478 5.47101C4.38807 5.47442 4.76698 5.32323 5.04988 5.04999C5.69992 4.39995 6.47164 3.88431 7.32096 3.53251C8.17028 3.18071 9.08058 2.99964 9.99988 2.99964C10.9192 2.99964 11.8295 3.18071 12.6788 3.53251C13.5281 3.88431 14.2998 4.39995 14.9499 5.04999C15.5999 5.70004 16.1156 6.47175 16.4674 7.32107C16.8192 8.1704 17.0002 9.0807 17.0002 10C17.0002 10.9193 16.8192 11.8296 16.4674 12.6789C16.1156 13.5282 15.5999 14.3 14.9499 14.95C14.6766 15.2329 14.5255 15.6118 14.5289 16.0051C14.5323 16.3984 14.69 16.7746 14.9682 17.0527C15.2463 17.3308 15.6225 17.4886 16.0158 17.492C16.4091 17.4954 16.788 17.3442 17.0709 17.071Z"
        fill="#91A2AE"
      />
    </svg>
  );
}
